<template>
    <div>
        <v-form v-model="isValid">
            <div class="d-grid">
                <div class="d-flex justify-center">
                    <v-date-picker-wrapper
                        v-model="dates"
                        multiple="range"
                        color="primary"
                        hide-header
                        :max="maxDate"
                        :first-day-of-week="1"
                        @update:modelValue="onDatesChanged"
                    />
                </div>
                <div>
                    <span
                        v-for="(error, index) in datePickerErrors"
                        :key="`error-date-picker-${index}`"
                        class="text-red animation-rize-shaking"
                    >
                        {{ error }}
                    </span>
                </div>
            </div>
            <div class="text-medium-emphasis">
                <template v-if="isValid">
                    La synchronisation sera effectuée pour la période du
                    {{ formatDate(dates[0]) }} au {{ formatDate(dates[dates.length - 1]) }} ({{
                        dates.length
                    }}
                    jours)
                </template>
            </div>
            <div class="d-flex justify-end">
                <v-btn
                    @click="connectorSync"
                    :disabled="!isValid"
                    class="mt-4"
                    rounded
                    elevation="0"
                >
                    Relancer la synchronisation
                </v-btn>
            </div>
        </v-form>
    </div>
</template>

<script lang="ts">
import { DialogAction } from "@/services/dialogAction";
import CONNECTOR_SYNC from "@/graphql/connector/ConnectorSync.gql";
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class SettingConnectorRefetchData extends Vue {
    @Prop({ default: null }) actions: { [key: string]: DialogAction } | null;
    @Prop({ default: null }) connectorId: string | null;
    @Prop({ default: null }) companyId: string | null;
    @Prop({ default: null }) origin: string | null;
    @Prop({ default: null }) application: string | null;
    @Prop({ default: null }) externalId: number | null;

    isValid = true;

    dates = [];

    datePickerErrors: string[] = [];

    beforeMount() {
        // pre-select interval of 3 days
        const now = new Date();
        for (let i = 3; i > 0; i--) {
            const date = new Date(now);
            date.setDate(date.getDate() - i);
            this.dates.push(date);
        }

        // if (this.actions && this.actions.action) {
        // }
    }

    onDatesChanged() {
        this.isValid = true;
        this.datePickerErrors = [];
        if (this.dates.length > 30) {
            this.isValid = false;
            this.datePickerErrors.push("La periode ne doit pas dépasser 30 jours");
        }
    }

    async connectorSync() {
        debugger;
        await this.$apollo.mutate({
            mutation: CONNECTOR_SYNC,
            variables: {
                companyId: this.companyId,
                origin: this.origin,
                application: this.application,
                externalId: this.externalId.toString(),
                startDate: this.dates[0],
                endDate: this.dates[this.dates.length - 1],
                id: this.connectorId,
            },
        });
    }

    get maxDate() {
        // yesterday
        const now = new Date();
        now.setDate(now.getDate() - 1);
        return now.toISOString().split("T")[0];
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }
}

export default toNative(SettingConnectorRefetchData);
</script>
